import { Toast } from "primereact/toast";
import { createContext, useContext, useState, useRef } from "react";
import { AuthContext } from "./AuthContext";
import { useNavigate } from "react-router-dom";

export const HabilidadesContext = createContext();
const HabilidadesContextProvider = ({ children }) => {
  const key = process.env.REACT_APP_TOKEN_KEY;
  const apiUrl = process.env.REACT_APP_URL_HABILIDADES;
  const toast = useRef(null);
  const navigate = useNavigate();
  const { setLoadGoogle, getTokenFromSessionStorage, setUsuario, usuario } =
    useContext(AuthContext);
  const [selectSkills, setSelectSkills] = useState([]);
  const [skillUser, setSkillUser] = useState([]);
  const [editSkill, setEditSkill] = useState(false);
  const [selectTecnologias, setSelectTecnologias] = useState([]);
  const [selectSubTecnologias, setSelectSubTecnologias] = useState([]);
  const [tecnologiaUser, setTenologiaUser] = useState([]);
  const [certificaciones, setCertificaciones] = useState([]);
  const [curriculum, setCurriculum] = useState([]);
  const [habilidadSeleccionada, setHabilidadSeleccionada] = useState("");
  const [selectNivelEstudio, setSelectNivelEstudio] = useState([]);
  const [nivelEstudioUser, setNivelEstudioUser] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openModalActualizacion, setOpenModalActualizacion] = useState(false);
  const [actualizacionDatos, setActualizacionDatos] = useState(false);
  const [recursosSkills, setRecursosSkills] = useState([]);
  const [practicas, setPracticas] = useState([]);
  const [skills, setSkills] = useState([]);
  const [usuarioPracticas, setUsuarioPracticas] = useState([]);
  const [usuarioSkills, setUsuarioSkills] = useState([]);
  const [practicaSkills, setPracticaSkills] = useState([]);

  // const getSkills = async () => {
  //   try {
  //     const token = getTokenFromSessionStorage(key);
  //     const options = {
  //       method: "GET",
  //       headers: {
  //         Authorization: "Bearer " + token,
  //         "Content-Type": "application/json",
  //       },
  //     };
  //     const response = await fetch(
  //       apiUrl + "/api/skillsComplementarias",
  //       options
  //     );

  //     if (response.ok) {
  //       const data = await response.json();
  //       setSelectSkills(data);
  //     }
  //     if (response.status === 401) {
  //       toast.current.show({
  //         severity: "error",
  //         summary: "Error",
  //         detail: "Expiró la sesión, vuelva a ingresar",
  //         life: 5000,
  //       });
  //       localStorage.clear();
  //       setUsuario(null);
  //       setLoadGoogle(false);
  //       navigate("/login", { replace: true });
  //       return [];
  //     }
  //   } catch (error) {}
  // };

  const getSkills = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/skills",
        options
      );

      if (response.ok) {
        const data = await response.json();
        setSkills(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };
  const getPracticas = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/practicas",
        options
      );

      if (response.ok) {
        const data = await response.json();
        setPracticas(data);
        return data
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const postSkills = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(apiUrl + "/api/skillsUsers", options);

      if (response.status === 201) {
        const data = await response.json();
        getSkillsUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Skills cargadas con éxito",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar la skill",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const updateSkills = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(apiUrl + "/api/skillsUsers", options);

      if (response.status === 200) {
        const data = await response.json();
        getSkillsUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se actualizaron tus skills correctamente",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al actualizar tus skills",
          life: 5000,
        });
        return [];
      }
    } catch (error) {
      console.error("Error al actualizar las skills del usuario:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Ocurrió un error inesperado",
        life: 5000,
      });
      return [];
    }
  };

  const getSkillsUser = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/skillsUsers/user", options);

      if (response.ok) {
        const data = await response.json();
        setSkillUser(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const deleteSkills = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(apiUrl + "/api/skillsUsers", options);

      if (response.status === 200) {
        const data = await response.json();
        getSkillsUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se elimino tu skill",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar la skill",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getTecnologias = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/technologies", options);

      if (response.ok) {
        const data = await response.json();
        setSelectTecnologias(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const getSubTecnologias = async (id) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/subtechnologies/" + id,
        options
      );

      if (response.ok) {
        const data = await response.json();
        setSelectSubTecnologias(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const getTecnologiasUser = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/technologiesUsers/user",
        options
      );

      if (response.ok) {
        const data = await response.json();
        setTenologiaUser(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const postTenologias = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(apiUrl + "/api/technologiesUsers", options);

      if (response.status === 200) {
        const data = await response.json();
        getTecnologiasUser();
        setEditSkill(false);
        toast.current.show({
          severity: "warn",
          summary: "Confirmación",
          detail: data.message,
          life: 5000,
        });
        return data;
      } else if (response.status === 201) {
        const data = await response.json();
        getTecnologiasUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: data.message,
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar las tecnologias",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const putTecnologias = async (skill) => {
    try {
      const { id, ...bodyWithoutId } = skill;
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyWithoutId),
      };
      const response = await fetch(
        apiUrl + "/api/technologiesUsers/" + skill.id,
        options
      );
      if (response.status === 200) {
        const data = await response.json();
        getTecnologiasUser();
        setEditSkill(false);
        toast.current.show({
          severity: "warn",
          summary: "Confirmación",
          detail: data.message,
          life: 5000,
        });
        return data;
      } else if (response.status === 201) {
        const data = await response.json();
        getTecnologiasUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: data.message,
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al actualizar la tecnologia",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const deleteTecnologias = async (id) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/technologiesUsers/" + id,
        options
      );

      if (response.status === 200) {
        const data = await response.json();
        getTecnologiasUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se elimino tu tecnologia",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar la tecnologia",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getCertificaciones = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/certificates", options);

      if (response.ok) {
        const data = await response.json();
        const certificaciones = await Promise.all(
          data.map(async (certificacion) => {
            const response = await fetch(
              apiUrl +
              "/api/certificates/downloadCertificate/" +
              certificacion._id,
              options
            );
            if (response.ok) {
              const blob = await response.blob();
              const fileUrl = URL.createObjectURL(blob);

              return { ...certificacion, fileUrl };
            } else {
              console.error(
                `Error descargando certificación ${certificacion._id}`
              );
              return { ...certificacion, fileUrl: null };
            }
          })
        );
        setCertificaciones(certificaciones);
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
      } else {
        console.error(
          "Error en la respuesta al obtener certificaciones:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error obteniendo certificaciones:", error);
    }
  };

  const postCertificaciones = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const formData = new FormData();
      formData.append("certificationTitle", skill.certificationTitle);
      formData.append("institutionName", skill.institutionName);

      if (skill.certificacionFile) {
        formData.append("certificationFile", skill.certificacionFile);
      }

      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
        body: formData,
      };

      const response = await fetch(apiUrl + "/api/certificates", options);

      if (response.status === 201) {
        const data = await response.json();
        getCertificaciones();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se añadió tu Certificación",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar la certificación",
          life: 5000,
        });
        return [];
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  const putCertificaciones = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const formData = new FormData();
      formData.append("certificationTitle", skill.certificationTitle);
      formData.append("institutionName", skill.institutionName);

      if (skill.certificacionFile) {
        formData.append("certificationFile", skill.certificacionFile);
      }

      const options = {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
        },
        body: formData,
      };

      const response = await fetch(
        apiUrl + "/api/certificates/" + skill.id,
        options
      );

      if (response.status === 200) {
        const data = await response.json();
        getCertificaciones();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se actualizo tu Certificación",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al actualizar la certificación",
          life: 5000,
        });
        return [];
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  const deleteCertificaciones = async (id) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/certificates/" + id, options);

      if (response.status === 200) {
        const data = await response.json();
        getCertificaciones();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se elimino tu certificación",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar la certificación",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getCurriculum = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/curriculum", options);

      if (response.ok) {
        const data = await response.json();
        const curriculum = await Promise.all(
          data.map(async (curriculum) => {
            const response = await fetch(
              apiUrl + "/api/curriculum/downloadCurriculum/" + curriculum._id,
              options
            );
            if (response.ok) {
              const blob = await response.blob();
              const fileUrl = URL.createObjectURL(blob);

              return { ...curriculum, fileUrl };
            } else {
              console.error(`Error descargando curriculum ${curriculum._id}`);
              return { ...curriculum, fileUrl: null };
            }
          })
        );
        setCurriculum(curriculum);
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
      } else {
        console.error(
          "Error en la respuesta al obtener curriculum:",
          response.statusText
        );
      }
    } catch (error) {
      console.error("Error obteniendo curriculum:", error);
    }
  };

  const postCurriculum = async (cv) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const formData = new FormData();

      if (cv.curriculumFile) {
        formData.append("curriculumFile", cv.curriculumFile);
      }

      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
        },
        body: formData,
      };

      const response = await fetch(apiUrl + "/api/curriculum", options);

      if (response.status === 201) {
        const data = await response.json();
        getCurriculum();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se añadió tu Curriculum",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar la curriculum",
          life: 5000,
        });
        return [];
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  const putCurriculum = async (cv) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const formData = new FormData();

      if (cv.curriculumFile) {
        formData.append("curriculumFile", cv.curriculumFile);
      }

      const options = {
        method: "PUT",
        headers: {
          Authorization: "Bearer " + token,
        },
        body: formData,
      };

      const response = await fetch(
        apiUrl + "/api/curriculum/" + cv.id,
        options
      );

      if (response.status === 200) {
        const data = await response.json();
        getCurriculum();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se actualizo tu Curriculum",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al actualizar la curriculum",
          life: 5000,
        });
        return [];
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  const deleteCurriculum = async (id) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/curriculum/" + id, options);

      if (response.status === 200) {
        const data = await response.json();
        getCurriculum();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se elimino tu curriculum",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar la curriculum",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getNivelEstudios = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/educationLevel", options);

      if (response.ok) {
        const data = await response.json();
        setSelectNivelEstudio(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const postNivelEstudios = async (skill) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(skill),
      };
      const response = await fetch(apiUrl + "/api/educationUser", options);

      if (response.status === 201) {
        const data = await response.json();
        getNivelEstudioUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se añadió tu nivel de estudio",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar el nivel de estudio",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getNivelEstudioUser = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/educationUser", options);

      if (response.ok) {
        const data = await response.json();
        setNivelEstudioUser(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const putNivelEstudios = async (skill) => {
    try {
      const { id, ...bodyWithoutId } = skill;
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "PuT",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyWithoutId),
      };
      const response = await fetch(
        apiUrl + "/api/educationUser/" + skill.id,
        options
      );

      if (response.status === 200) {
        const data = await response.json();
        getNivelEstudioUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se actualizalo tu nivel de estudio",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al actualizar el nivel de estudio",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const deleteNivelEstudio = async (id) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/educationUser/" + id,
        options
      );

      if (response.status === 200) {
        const data = await response.json();
        getNivelEstudioUser();
        setEditSkill(false);
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se elimino tu nivel de estudio",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar el nivel de estudio",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getExcelMatrizHabilidades = async () => {
    try {
      setIsLoading(true);
      const token = getTokenFromSessionStorage(key);
      const respuesta = await fetch(apiUrl + "/api/download-skillsMatrix", {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      });

      if (respuesta.status === 200) {
        const blob = await respuesta.blob();
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "matriz_habilidades.xlsx";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Excel descargado con éxito.",
          life: 5000,
        });
      } else {
        console.error("Error: ", respuesta.status, respuesta.statusText);
      }
    } catch (error) {
      console.error("Error al descargar los archivos", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Error al descargar los archivos",
        life: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  const getAlertaActualizacionDatos = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/skillsProfile", options);

      if (response.ok) {
        const data = await response.json();
        setActualizacionDatos(data);
        data?.notification === true && setOpenModalActualizacion(true);
      }
    } catch (error) { }
  };

  const postActualizacionDatos = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(apiUrl + "/api/skillsProfile", options);

      if (response.status === 201) {
        const data = await response.json();
        getAlertaActualizacionDatos();
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Hubo un eeror",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const postSugerencias = async (sugerencias) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(sugerencias),
      };
      const response = await fetch(apiUrl + "/api/technologiesSugest", options);

      if (response.status === 200) {
        const data = await response.json();
        toast.current.show({
          severity: "warn",
          summary: "Confirmación",
          detail: "La tecnología ya existe",
          life: 50000,
        });
        return data;
      } else if (response.status === 201) {
        const data = await response.json();
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se añadió tu sugerencia",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar la sugerencia",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getRecursosSkills = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/recursosProfile/" + usuario.Legajo,
        options
      );

      if (response.ok) {
        const data = await response.json();
        setRecursosSkills(data);
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const postValidarRecursosSkills = async (recursos) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(recursos),
      };
      const response = await fetch(apiUrl + "/api/recursosProfile", options);

      if (response.status === 201) {
        const data = await response.json();
        getRecursosSkills();
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Se validaron las habilidades correctamente",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al validar las habilidades",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getUsuarioPracticas = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/usuario/practicas",
        options
      );

      if (response.ok) {
        const data = await response.json();
        setUsuarioPracticas(data);
        return data
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const postUsuarioPracticas = async (data) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(apiUrl + "/api/usuario/practicas", options);

      if (response.status === 200 || response.status === 201) {
        const data = await response.json();
        getUsuarioPracticas();
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Prácticas del usuario guardadas exitosamente",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const delUsuarioPracticas = async (data) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(apiUrl + "/api/usuario/practicas/many", options);
      if (response.status === 200) {
        const data = await response.json();
        getUsuarioPracticas();
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getUsuarioSkills = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/usuario/skills",
        options
      );

      if (response.ok) {
        const data = await response.json();
        setUsuarioSkills(data);
        return data
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  const postUsuarioSkills = async (data) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const dataTipo = data.map(item => { return { ...item, tipo: "p" } });
      const options = {
        method: "POST",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(dataTipo),
      };
      const response = await fetch(apiUrl + "/api/usuario/skills", options);

      if (response.status === 200 || response.status === 201) {
        const data = await response.json();
        getUsuarioPracticas();
        toast.current.show({
          severity: "success",
          summary: "Confirmación",
          detail: "Skills del usuario guardadas exitosamente",
          life: 5000,
        });
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al guardar",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const delUsuarioSkills = async (data) => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(apiUrl + "/api/usuario/skills/many", options);
      if (response.status === 200) {
        const data = await response.json();
        getUsuarioPracticas();
        return data;
      } else if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      } else {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Error al eliminar",
          life: 5000,
        });
        return [];
      }
    } catch (error) { }
  };

  const getPracticaSkills = async () => {
    try {
      const token = getTokenFromSessionStorage(key);
      const options = {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      };
      const response = await fetch(
        apiUrl + "/api/usuario/practica-skills",
        options
      );

      if (response.ok) {
        const data = await response.json();
        setPracticaSkills(data);
        return data
      }
      if (response.status === 401) {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: "Expiró la sesión, vuelva a ingresar",
          life: 5000,
        });
        localStorage.clear();
        setUsuario(null);
        setLoadGoogle(false);
        navigate("/login", { replace: true });
        return [];
      }
    } catch (error) { }
  };

  return (
    <HabilidadesContext.Provider
      value={{
        selectSkills,
        getSkills,
        postSkills,
        getSkillsUser,
        skillUser,
        editSkill,
        updateSkills,
        setEditSkill,
        deleteSkills,
        getTecnologias,
        selectTecnologias,
        getSubTecnologias,
        selectSubTecnologias,
        getCertificaciones,
        certificaciones,
        postCertificaciones,
        putCertificaciones,
        getCurriculum,
        curriculum,
        postCurriculum,
        putCurriculum,
        deleteCurriculum,
        habilidadSeleccionada,
        setHabilidadSeleccionada,
        deleteCertificaciones,
        getNivelEstudios,
        selectNivelEstudio,
        postNivelEstudios,
        nivelEstudioUser,
        getNivelEstudioUser,
        putNivelEstudios,
        deleteNivelEstudio,
        getTecnologiasUser,
        tecnologiaUser,
        postTenologias,
        deleteTecnologias,
        putTecnologias,
        getExcelMatrizHabilidades,
        isLoading,
        openModalActualizacion,
        setOpenModalActualizacion,
        getAlertaActualizacionDatos,
        actualizacionDatos,
        postActualizacionDatos,
        postSugerencias,
        getRecursosSkills,
        postValidarRecursosSkills,
        recursosSkills,
        practicas,
        getPracticas,
        setPracticas,
        skills,
        setSkills,
        getUsuarioPracticas,
        postUsuarioPracticas,
        delUsuarioPracticas,
        getUsuarioSkills,
        postUsuarioSkills,
        delUsuarioSkills,
        usuarioPracticas,
        usuarioSkills,
        getPracticaSkills,
        practicaSkills,
      }}
    >
      {children}
      <Toast ref={toast} />
    </HabilidadesContext.Provider>
  );
};

export default HabilidadesContextProvider;
